import { Trigger, Editor } from '../types';

const defaultAllowedTriggers = {
  entrance: false,
  ongoing: false,
  scroll: false,
};

const allowedTriggersByComp = new Map<string, Record<Trigger, boolean>>([
  // YES ANIMATION
  // -----------------------
  // Special
  ['PopupContainer', { entrance: true, ongoing: false, scroll: false }],
  ['WRichText', { entrance: true, ongoing: true, scroll: true }],
  ['Footer', { entrance: true, ongoing: false, scroll: false }],
  ['FooterContainer', { entrance: true, ongoing: false, scroll: false }],
  ['TPAWidget', { entrance: true, ongoing: false, scroll: true }],

  // TPA Galleries
  ['Masonry', { entrance: true, ongoing: false, scroll: true }],
  ['Accordion', { entrance: true, ongoing: false, scroll: true }],
  ['Impress', { entrance: true, ongoing: false, scroll: true }],
  ['Freestyle', { entrance: true, ongoing: false, scroll: true }],
  ['Collage', { entrance: true, ongoing: false, scroll: true }],
  ['Honeycomb', { entrance: true, ongoing: false, scroll: true }],
  ['StripShowcase', { entrance: true, ongoing: false, scroll: true }],
  ['StripSlideshow', { entrance: true, ongoing: false, scroll: true }],
  ['Thumbnails', { entrance: true, ongoing: false, scroll: true }],
  ['TPA3DGallery', { entrance: true, ongoing: false, scroll: true }],
  ['TPA3DCarousel', { entrance: true, ongoing: false, scroll: true }],

  // iFrame Components
  ['FlickrBadgeWidget', { entrance: true, ongoing: false, scroll: true }],
  ['GoogleMap', { entrance: true, ongoing: false, scroll: true }],
  ['PinItPinWidget', { entrance: true, ongoing: false, scroll: true }],
  ['PinterestPinIt', { entrance: true, ongoing: false, scroll: true }],
  ['FacebookLikeBox', { entrance: true, ongoing: false, scroll: true }],
  ['SkypeCallButton', { entrance: true, ongoing: false, scroll: true }],
  ['SoundCloudWidget', { entrance: true, ongoing: false, scroll: true }],
  ['SpotifyFollow', { entrance: true, ongoing: false, scroll: true }],
  ['SpotifyPlayer', { entrance: true, ongoing: false, scroll: true }],
  ['Video', { entrance: true, ongoing: false, scroll: true }],
  ['VKShareButton', { entrance: true, ongoing: false, scroll: true }],
  ['WTwitterTweet', { entrance: true, ongoing: false, scroll: true }],
  ['WTwitterFollow', { entrance: true, ongoing: false, scroll: true }],
  ['YouTubeSubscribeButton', { entrance: true, ongoing: false, scroll: true }],

  // SHOULD HAVE ANIMATIONS
  ['ImageButton', { entrance: true, ongoing: true, scroll: true }],
  ['RSSButton', { entrance: true, ongoing: true, scroll: true }],
  ['VerticalAnchorsMenu', { entrance: true, ongoing: false, scroll: true }],
  ['VerticalMenu', { entrance: true, ongoing: false, scroll: true }],
  ['AudioPlayer', { entrance: true, ongoing: false, scroll: true }],
  ['ClipArt', { entrance: true, ongoing: true, scroll: true }],
  ['SiteButton', { entrance: true, ongoing: true, scroll: true }],
  ['MatrixGallery', { entrance: true, ongoing: false, scroll: true }],
  ['MediaRichText', { entrance: true, ongoing: true, scroll: true }],
  ['PayPalButton', { entrance: true, ongoing: false, scroll: true }],
  ['PinterestFollow', { entrance: true, ongoing: true, scroll: true }],
  ['SliderGallery', { entrance: true, ongoing: false, scroll: true }],
  ['SlideShowGallery', { entrance: true, ongoing: false, scroll: true }],
  ['TwitterFeed', { entrance: true, ongoing: false, scroll: true }],
  ['VerticalRepeater', { entrance: true, ongoing: false, scroll: true }],
  ['WPhoto', { entrance: true, ongoing: true, scroll: true }],
  ['LoginButton', { entrance: true, ongoing: false, scroll: true }],
  ['AdminLoginButton', { entrance: true, ongoing: false, scroll: true }],
  ['BoxSlideShow', { entrance: true, ongoing: false, scroll: true }],
  ['Checkbox', { entrance: true, ongoing: false, scroll: true }],
  ['ComboBoxInput', { entrance: true, ongoing: false, scroll: true }],
  ['DynamicContactForm', { entrance: true, ongoing: false, scroll: true }],
  ['ContactForm', { entrance: true, ongoing: false, scroll: true }],
  ['VectorImage', { entrance: true, ongoing: true, scroll: true }],
  ['Container', { entrance: true, ongoing: true, scroll: true }],
  ['DatePicker', { entrance: true, ongoing: false, scroll: true }],
  ['DocumentMedia', { entrance: true, ongoing: false, scroll: true }],
  ['DropDownMenu', { entrance: true, ongoing: false, scroll: false }],
  ['ExpandableMenu', { entrance: true, ongoing: false, scroll: true }],
  ['WFacebookLike', { entrance: true, ongoing: false, scroll: true }],
  ['FileUploader', { entrance: true, ongoing: false, scroll: true }],
  ['Group', { entrance: true, ongoing: true, scroll: true }],
  ['FormContainer', { entrance: true, ongoing: false, scroll: true }],
  ['MediaPlayer', { entrance: true, ongoing: true, scroll: true }],
  ['PaginatedGridGallery', { entrance: true, ongoing: false, scroll: true }],
  ['InlinePopup', { entrance: true, ongoing: false, scroll: false }],
  ['InlinePopupToggle', { entrance: true, ongoing: false, scroll: false }],
  ['FacebookShare', { entrance: true, ongoing: true, scroll: true }],
  ['ItunesButton', { entrance: true, ongoing: true, scroll: true }],
  ['LanguageSelector', { entrance: true, ongoing: false, scroll: true }],
  ['LinkBar', { entrance: true, ongoing: true, scroll: true }],
  ['LoginSocialBar', { entrance: true, ongoing: false, scroll: true }],
  ['MediaBox', { entrance: true, ongoing: false, scroll: false }],
  ['MediaContainer', { entrance: true, ongoing: false, scroll: false }],
  ['PopupCloseTextButton', { entrance: true, ongoing: false, scroll: false }],
  ['PopupCloseIconButton', { entrance: true, ongoing: false, scroll: false }],
  ['RadioGroup', { entrance: true, ongoing: false, scroll: true }],
  ['Repeater', { entrance: true, ongoing: false, scroll: true }],
  ['RichTextBox', { entrance: true, ongoing: false, scroll: true }],
  ['SingleAudioPlayer', { entrance: true, ongoing: false, scroll: true }],
  ['TextInput', { entrance: true, ongoing: false, scroll: true }],
  ['Icon', { entrance: true, ongoing: false, scroll: false }],
  ['OptionsListInput', { entrance: true, ongoing: false, scroll: true }],
  ['SelectOptionsList', { entrance: true, ongoing: false, scroll: true }],
  ['SubscribeForm', { entrance: true, ongoing: false, scroll: true }],
  ['TinyMenu', { entrance: true, ongoing: true, scroll: true }],
  ['LineShareButton', { entrance: true, ongoing: true, scroll: true }],
  ['TextMask', { entrance: true, ongoing: true, scroll: true }],
  ['TimePicker', { entrance: true, ongoing: false, scroll: true }],
  ['ToggleSwitch', { entrance: true, ongoing: false, scroll: true }],
  ['VideoPlayer', { entrance: true, ongoing: false, scroll: true }],
  ['FiveGridLine', { entrance: true, ongoing: true, scroll: true }],
  ['VerticalLine', { entrance: true, ongoing: true, scroll: true }],
  ['CheckboxGroup', { entrance: true, ongoing: false, scroll: true }],
  ['LottieEmbed', { entrance: true, ongoing: false, scroll: false }],
  ['Tabs', { entrance: true, ongoing: false, scroll: true }],
  ['ProgressBar', { entrance: true, ongoing: false, scroll: true }],
  ['RangeSlider', { entrance: true, ongoing: false, scroll: true }],
  ['RatingsDisplay', { entrance: true, ongoing: false, scroll: true }],
  ['RatingsInput', { entrance: true, ongoing: false, scroll: true }],
  ['Slider', { entrance: true, ongoing: false, scroll: true }],
  ['StylableButton', { entrance: true, ongoing: true, scroll: true }],
  ['StylableHorizontalMenu', { entrance: true, ongoing: false, scroll: true }],
  ['SearchBox', { entrance: true, ongoing: false, scroll: true }],
  ['SelectionTagsList', { entrance: true, ongoing: false, scroll: true }],
  ['SignatureInput', { entrance: true, ongoing: false, scroll: true }],
  ['TextAreaInput', { entrance: true, ongoing: false, scroll: true }],
  ['ImageButtonWithText', { entrance: true, ongoing: true, scroll: true }],
  ['MultiStateBox', { entrance: true, ongoing: false, scroll: true }],
  ['Breadcrumbs', { entrance: true, ongoing: false, scroll: true }],
  ['AddressInput', { entrance: true, ongoing: false, scroll: true }],
  ['CollapsibleText', { entrance: true, ongoing: true, scroll: true }],
  ['BackToTopButton', { entrance: true, ongoing: true, scroll: false }],
  ['MenuContainer', { entrance: true, ongoing: false, scroll: false }],
  ['CustomElementComponent', { entrance: true, ongoing: false, scroll: true }],
  ['ProGallery', { entrance: true, ongoing: false, scroll: true }],
  ['Table', { entrance: true, ongoing: false, scroll: true }],
  ['Captcha', { entrance: true, ongoing: false, scroll: true }],
  // Fixes for failing tests - June 2024
  ['StateBox', { entrance: true, ongoing: false, scroll: false }],
  ['RefComponent', { entrance: true, ongoing: false, scroll: false }],
  ['AppWidget', { entrance: true, ongoing: false, scroll: false }],
  // Was missing from the list July 2024
  ['MenuToggle', { entrance: true, ongoing: false, scroll: false }],

  // NO ANIMATION
  // -----------------------

  // Uncategorized components
  ['ErasableTextInput', { entrance: false, ongoing: false, scroll: false }],
  ['InfoTip', { entrance: false, ongoing: false, scroll: false }],
  ['InputWithValidation', { entrance: false, ongoing: false, scroll: false }],
  ['MessageView', { entrance: false, ongoing: false, scroll: false }],
  ['Area', { entrance: false, ongoing: false, scroll: false }],

  ['TextArea', { entrance: false, ongoing: false, scroll: false }],
  ['Toggle', { entrance: false, ongoing: false, scroll: false }],
  ['MobileActionsMenu', { entrance: false, ongoing: false, scroll: false }],

  ['uploadName', { entrance: false, ongoing: false, scroll: false }],
  ['Grid', { entrance: false, ongoing: false, scroll: false }],
  ['Popover', { entrance: false, ongoing: false, scroll: false }],

  ['MobuiButton', { entrance: false, ongoing: false, scroll: false }],
  ['MobuiImage', { entrance: false, ongoing: false, scroll: false }],
  ['MobuiSwitch', { entrance: false, ongoing: false, scroll: false }],
  ['MobuiText', { entrance: false, ongoing: false, scroll: false }],
  ['MobuiTextInput', { entrance: false, ongoing: false, scroll: false }],
  ['MobuiContainer', { entrance: false, ongoing: false, scroll: false }],
  ['SocialAuth', { entrance: false, ongoing: false, scroll: false }],
  ['StretchedContainer', { entrance: false, ongoing: false, scroll: false }],
  ['WsrButton', { entrance: false, ongoing: false, scroll: false }],
  ['WsrHeading', { entrance: false, ongoing: false, scroll: false }],
  ['WsrIconButton', { entrance: false, ongoing: false, scroll: false }],
  ['WsrInfoIcon', { entrance: false, ongoing: false, scroll: false }],
  ['WsrInput', { entrance: false, ongoing: false, scroll: false }],
  ['WsrNumberInput', { entrance: false, ongoing: false, scroll: false }],
  ['WsrText', { entrance: false, ongoing: false, scroll: false }],
  ['WsrTextButton', { entrance: false, ongoing: false, scroll: false }],
  ['WsrToggleSwitch', { entrance: false, ongoing: false, scroll: false }],
  ['WutRadioButton', { entrance: false, ongoing: false, scroll: false }],
  ['WbuAccordion', { entrance: false, ongoing: false, scroll: false }],
  ['WbuBackButton', { entrance: false, ongoing: false, scroll: false }],
  ['WbuButton', { entrance: false, ongoing: false, scroll: false }],
  ['WbuCheckboxGroup', { entrance: false, ongoing: false, scroll: false }],
  ['WbuColorPicker', { entrance: false, ongoing: false, scroll: false }],
  ['WbuColorSelector', { entrance: false, ongoing: false, scroll: false }],
  ['WbuDatePicker', { entrance: false, ongoing: false, scroll: false }],
  ['WbuDrillDown', { entrance: false, ongoing: false, scroll: false }],
  ['WbuDropdown', { entrance: false, ongoing: false, scroll: false }],
  ['WbuEmptyState', { entrance: false, ongoing: false, scroll: false }],
  ['WbuFontAndColorPicker', { entrance: false, ongoing: false, scroll: false }],
  ['WbuHorizontalTabs', { entrance: false, ongoing: false, scroll: false }],
  ['WbuLeftTextButton', { entrance: false, ongoing: false, scroll: false }],
  ['WbuMultilineTextInput', { entrance: false, ongoing: false, scroll: false }],
  ['WbuNotificationBanner', { entrance: false, ongoing: false, scroll: false }],
  ['WbuNumericInput', { entrance: false, ongoing: false, scroll: false }],
  ['WbuRadioButtonGroup', { entrance: false, ongoing: false, scroll: false }],
  ['WbuRichText', { entrance: false, ongoing: false, scroll: false }],
  ['WbuSectionDivider', { entrance: false, ongoing: false, scroll: false }],
  ['WbuSlider', { entrance: false, ongoing: false, scroll: false }],
  ['WbuTextInput', { entrance: false, ongoing: false, scroll: false }],
  ['WbuThumbnails', { entrance: false, ongoing: false, scroll: false }],
  ['WbuToggleSwitch', { entrance: false, ongoing: false, scroll: false }],
  ['WutAvatar', { entrance: false, ongoing: false, scroll: false }],
  ['WutAvatarGroup', { entrance: false, ongoing: false, scroll: false }],

  // Containers
  ['Column', { entrance: false, ongoing: false, scroll: false }],
  ['StripContainer', { entrance: false, ongoing: false, scroll: false }],
  [
    'StripContainerSlideShow',
    { entrance: false, ongoing: false, scroll: false },
  ],
  [
    'StripContainerSlideShowSlide',
    { entrance: false, ongoing: false, scroll: false },
  ],
  ['StateBoxState', { entrance: false, ongoing: false, scroll: false }],
  ['StateBoxFormState', { entrance: false, ongoing: false, scroll: false }],
  ['StateStrip', { entrance: false, ongoing: false, scroll: false }],
  ['StateStripState', { entrance: false, ongoing: false, scroll: false }],
  ['StripColumnsContainer', { entrance: false, ongoing: false, scroll: false }],
  ['ClassicSection', { entrance: false, ongoing: false, scroll: false }],
  ['BoxSlideShowSlide', { entrance: false, ongoing: false, scroll: false }],
  ['Section', { entrance: false, ongoing: false, scroll: false }],

  // Media Components - no animation
  ['MediaControls', { entrance: false, ongoing: false, scroll: false }],
  ['MediaOverlayControls', { entrance: false, ongoing: false, scroll: false }],
  ['MediaControlPlay', { entrance: false, ongoing: false, scroll: false }],
  ['MediaControlVolume', { entrance: false, ongoing: false, scroll: false }],
  [
    'MediaControlFullscreen',
    { entrance: false, ongoing: false, scroll: false },
  ],
  ['MediaControlProgress', { entrance: false, ongoing: false, scroll: false }],
  ['MediaControlTime', { entrance: false, ongoing: false, scroll: false }],
  [
    'MediaControlStoryboard',
    { entrance: false, ongoing: false, scroll: false },
  ],

  // Definitly no animation
  ['RadioButton', { entrance: false, ongoing: false, scroll: false }],
  ['ControlTypes', { entrance: false, ongoing: false, scroll: false }],
  [
    'SettingsPanelContainer',
    { entrance: false, ongoing: false, scroll: false },
  ],
  ['MenuButton', { entrance: false, ongoing: false, scroll: false }],
  ['MasterPage', { entrance: false, ongoing: false, scroll: false }],
  ['BgImageStrip', { entrance: false, ongoing: false, scroll: false }],
  ['Displayer', { entrance: false, ongoing: false, scroll: false }],
  ['QuickActionBar', { entrance: false, ongoing: false, scroll: false }],
  ['QuickActionBarItem', { entrance: false, ongoing: false, scroll: false }],
  ['TouchMediaZoom', { entrance: false, ongoing: false, scroll: false }],
  ['TouchMediaZoomItem', { entrance: false, ongoing: false, scroll: false }],
  ['ExitMobileMode', { entrance: false, ongoing: false, scroll: false }],
  ['WGooglePlusOne', { entrance: false, ongoing: false, scroll: false }],
  ['SvgShape', { entrance: false, ongoing: false, scroll: false }],
  ['SvgPrimitive', { entrance: false, ongoing: false, scroll: false }],
  ['SiteRegionContainer', { entrance: false, ongoing: false, scroll: false }],
  ['HoverBox', { entrance: false, ongoing: false, scroll: false }],
  ['PageGroup', { entrance: false, ongoing: false, scroll: false }],
  ['ScreenWidthContainer', { entrance: false, ongoing: false, scroll: false }],
  ['SiteBackground', { entrance: false, ongoing: false, scroll: false }],
  ['EnterPasswordDialog', { entrance: false, ongoing: false, scroll: false }],
  ['NotificationDialog', { entrance: false, ongoing: false, scroll: false }],
  ['SignUpDialog', { entrance: false, ongoing: false, scroll: false }],
  ['MemberLoginDialog', { entrance: false, ongoing: false, scroll: false }],
  [
    'RequestPasswordResetDialog',
    { entrance: false, ongoing: false, scroll: false },
  ],
  ['ResetPasswordDialog', { entrance: false, ongoing: false, scroll: false }],
  [
    'EcomCheckoutMessageDialog',
    { entrance: false, ongoing: false, scroll: false },
  ],
  ['ZoomedImage', { entrance: false, ongoing: false, scroll: false }],
  ['imageZoom', { entrance: false, ongoing: false, scroll: false }],
  ['ImageZoomDisplayer', { entrance: false, ongoing: false, scroll: false }],
  ['AppPartZoom', { entrance: false, ongoing: false, scroll: false }],
  ['MediaZoom', { entrance: false, ongoing: false, scroll: false }],
  ['MobileMediaZoom', { entrance: false, ongoing: false, scroll: false }],
  ['HeaderSection', { entrance: false, ongoing: false, scroll: false }],
  ['Header', { entrance: false, ongoing: false, scroll: false }],
  ['BoltComponent', { entrance: false, ongoing: false, scroll: false }],
  ['bgMedia', { entrance: false, ongoing: false, scroll: false }],
  ['bgImage', { entrance: false, ongoing: false, scroll: false }],
  ['html5Video', { entrance: false, ongoing: false, scroll: false }],
  ['webglMedia', { entrance: false, ongoing: false, scroll: false }],
  ['iframeVideo', { entrance: false, ongoing: false, scroll: false }],
  ['bgOverlay', { entrance: false, ongoing: false, scroll: false }],

  ['WSiteStructure', { entrance: false, ongoing: false, scroll: false }],
  ['Page', { entrance: false, ongoing: false, scroll: false }],
  ['AppPage', { entrance: false, ongoing: false, scroll: false }],
  ['Anchor', { entrance: false, ongoing: false, scroll: false }],
  ['FlashComponent', { entrance: false, ongoing: false, scroll: false }],
  ['PagesContainer', { entrance: false, ongoing: false, scroll: false }],
  ['HeaderContainer', { entrance: false, ongoing: false, scroll: false }],
  ['TPASection', { entrance: false, ongoing: false, scroll: false }],
  ['TPAGluedWidget', { entrance: false, ongoing: false, scroll: false }],
  ['TPAMultiSection', { entrance: false, ongoing: false, scroll: false }],
  ['AppPart', { entrance: false, ongoing: false, scroll: false }],
  ['AppPart2', { entrance: false, ongoing: false, scroll: false }],
  ['HtmlComponent', { entrance: false, ongoing: false, scroll: false }],
  ['AppController', { entrance: false, ongoing: false, scroll: false }],
  ['UnsupportedComponent', { entrance: false, ongoing: false, scroll: false }],
  ['TestComp', { entrance: false, ongoing: false, scroll: false }],
  ['Image', { entrance: false, ongoing: false, scroll: false }],
  ['EbayItemsBySeller', { entrance: false, ongoing: false, scroll: false }],
  ['LinkBarItem', { entrance: false, ongoing: false, scroll: false }],
  ['MusicPlayer', { entrance: false, ongoing: false, scroll: false }],
  ['TextOption', { entrance: false, ongoing: false, scroll: false }],
  ['MobileTextOption', { entrance: false, ongoing: false, scroll: false }],
  ['ColorOption', { entrance: false, ongoing: false, scroll: false }],
  ['MobileColorOption', { entrance: false, ongoing: false, scroll: false }],
  ['NumericStepper', { entrance: false, ongoing: false, scroll: false }],
  ['WFacebookComment', { entrance: false, ongoing: false, scroll: false }],
  ['DisqusComments', { entrance: false, ongoing: false, scroll: false }],
  ['SlotsPlaceholder', { entrance: false, ongoing: false, scroll: false }],
  ['TPAModal', { entrance: false, ongoing: false, scroll: false }],
  ['TPAPopup', { entrance: false, ongoing: false, scroll: false }],
  ['TPAPreloaderOverlay', { entrance: false, ongoing: false, scroll: false }],
  [
    'TPAUnavailableMessageOverlay',
    { entrance: false, ongoing: false, scroll: false },
  ],
  ['TPAWorker', { entrance: false, ongoing: false, scroll: false }],
  ['TPAPlaceholder', { entrance: false, ongoing: false, scroll: false }],
  ['CloudGluedWidget', { entrance: false, ongoing: false, scroll: false }],
  ['CloudWidget', { entrance: false, ongoing: false, scroll: false }],
  ['MegaMenuContainerItem', { entrance: false, ongoing: false, scroll: false }],
  ['OldBlogDeprecation', { entrance: false, ongoing: false, scroll: false }],
  ['Pagination', { entrance: false, ongoing: false, scroll: false }],
  ['SingleTab', { entrance: false, ongoing: false, scroll: false }],
  ['AccordionItem', { entrance: false, ongoing: false, scroll: false }],
  ['AccordionContainer', { entrance: false, ongoing: false, scroll: false }],
]);

const compMobileOverrides = new Map<string, Partial<Record<Trigger, boolean>>>([
  ['Column', { entrance: true }],
  // ['StripColumnsContainer', { entrance: true }],
  ['StripContainerSlideShow', { entrance: true }],
]);

/**
 * Retrieves the allowed triggers for a given component.
 * @param compName - The name of the component.
 * @param options - Optional parameters for additional configuration.
 * @param options.editor - "DESKTOP" | "MOBILE".
 * @returns An object containing the allowed triggers for the component.
 */
export function getAllowedTriggersForComp(
  compName: string,
  options: { editor?: Editor } = {},
): Record<Trigger, boolean> {
  const allowed = allowedTriggersByComp.get(compName) ?? defaultAllowedTriggers;
  if (options.editor === 'MOBILE') {
    const mobileOverridesComponent = compMobileOverrides.get(compName);
    return { ...allowed, ...mobileOverridesComponent };
  }
  return allowed;
}

/**
 * Determines whether a trigger is allowed for the given component names.
 *
 * @param compNames - An array of component names or a single component name.
 * @param trigger - The trigger to check.
 * @param options - Optional parameters for additional configuration.
 * @param options.editor - "DESKTOP" | "MOBILE".
 * @returns A boolean indicating whether the trigger is allowed.
 */
export function isTriggerAllowed(
  compNames: string[] | string,
  trigger: Trigger,
  options?: { editor?: Editor },
): boolean {
  return getAllowedTriggers(compNames, options)[trigger];
}

/**
 * Retrieves the allowed triggers for the specified component names.
 *
 * @param compNames - An array of component names or a single component name.
 * @param options - Optional object containing additional options.
 * @param options.editor - "DESKTOP" | "MOBILE".
 * @returns An object mapping each trigger to a boolean value indicating whether it is allowed.
 */
export function getAllowedTriggers(
  compNames: string[] | string,
  options?: { editor?: Editor },
): Record<Trigger, boolean> {
  compNames = Array.isArray(compNames) ? compNames : [compNames];

  return compNames.reduce(
    (acc, componentName) => {
      const allowedTriggersForComp = getAllowedTriggersForComp(
        componentName,
        options,
      );
      return {
        entrance: acc.entrance && allowedTriggersForComp.entrance,
        ongoing: acc.ongoing && allowedTriggersForComp.ongoing,
        scroll: acc.scroll && allowedTriggersForComp.scroll,
      };
    },
    { entrance: true, ongoing: true, scroll: true } as Record<Trigger, boolean>,
  );
}

/**
 * Return false if the component is not allowed to have any animation,
 * for multiple components return false only if every component returns false
 * @param compNames - An array of component names or a single component name.
 * @param options - Optional object containing additional options.
 * @param options.editor - "DESKTOP" | "MOBILE".
 * @returns boolean
 */
export function isAnimatable(
  compNames: string[] | string,
  options?: { editor?: Editor },
): boolean {
  const allowedTriggers = getAllowedTriggers(compNames, options);
  return Object.values(allowedTriggers).some((v) => v);
}
